function initializeCusBlogBody(root) {
  const scope = root || document;
  scope.querySelectorAll('[data-cus-blog-body]').forEach((body) => {
    body.querySelectorAll('table').forEach((table) => {
      if (table.parentElement && table.parentElement.classList.contains('cus-blog-table-scroll')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'cus-blog-table-scroll';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });

    body.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      const parent = link.parentElement;
      if (!parent || parent.tagName !== 'P') return;
      if (parent.textContent.trim() === link.textContent.trim()) {
        parent.classList.add('cus-blog-product-link-row');
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeCusBlogBody(document));
} else {
  initializeCusBlogBody(document);
}

document.addEventListener('shopify:section:load', (event) => initializeCusBlogBody(event.target));
